<template>
  <div v-bind:class="{expanded}">
    <div @click="clicked">
      <font-awesome-icon icon="angle-double-down" v-if="expanded" />
      <font-awesome-icon icon="angle-double-down" rotation="270" v-if="!expanded" />
    <strong> {{title}}</strong></div>
    <div v-html="text" v-if="expanded"></div>
  </div>
</template>
<script>
export default {
  name: "Article",
  props: {
    title: String,
    text: String,
    status: String
  },
  data (){
      return {
          expanded: false
      }
  },
  methods: {
      clicked (){
          this.expanded = !this.expanded;
      }
  }
};
</script>
<style scoped>
div {
    text-align: left;
    max-width: 600px;
    padding-top: 1em;
   
}

.expanded > div:last-child {
    background: rgb(230, 230, 195);
     border: 1px solid black;
     padding: 1em;
}
strong{
  color:black;
  opacity: 0.9;
  padding:0.2em;
  margin-left: 0.2em;
}
</style>